"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _IpmMessageService_http;
Object.defineProperty(exports, "__esModule", { value: true });
exports.IpmMessageService = void 0;
const superstruct_1 = require("superstruct");
const IpmDownloader_1 = require("./IpmDownloader");
const utils_1 = require("./utils");
const InsightsClient_1 = require("./InsightsClient");
const AxiosHttpRequester_1 = require("../network/AxiosHttpRequester");
class IpmMessageService {
    constructor(context) {
        this.context = context;
        _IpmMessageService_http.set(this, new AxiosHttpRequester_1.AxiosHttpRequester());
        this.ipmDownloader = new IpmDownloader_1.IpmDownloader({ analytics: context.analytics, http: __classPrivateFieldGet(this, _IpmMessageService_http, "f") });
    }
    getMessage(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            const token = (0, utils_1.oxygenTokenFrom)(this.context.analytics);
            if (!token) {
                return null;
            }
            return (yield (0, InsightsClient_1.query)({ filter, name: "insight" }, {
                http: __classPrivateFieldGet(this, _IpmMessageService_http, "f"),
                env: (0, utils_1.envFrom)(this.context.analytics),
                token,
            })).data.insight;
        });
    }
    getMessages(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            const token = (0, utils_1.oxygenTokenFrom)(this.context.analytics);
            if (!token) {
                return null;
            }
            return (yield (0, InsightsClient_1.query)({ filter, name: "insights" }, { http: __classPrivateFieldGet(this, _IpmMessageService_http, "f"), env: (0, utils_1.envFrom)(this.context.analytics), token })).data.insights;
        });
    }
    submitMessage(insight) {
        return __awaiter(this, void 0, void 0, function* () {
            const token = (0, utils_1.oxygenTokenFrom)(this.context.analytics);
            if (!token) {
                throw new Error("User token is not available");
            }
            return (0, InsightsClient_1.submit)(new Uint8Array(Object.values(insight.binaryPayload)), {
                http: __classPrivateFieldGet(this, _IpmMessageService_http, "f"),
                env: (0, utils_1.envFrom)(this.context.analytics),
                token,
            });
        });
    }
    getRulesEngines() {
        return __awaiter(this, void 0, void 0, function* () {
            const product = (0, utils_1.productLineCodeFrom)(this.context.analytics);
            const version = (0, utils_1.productVersionFrom)(this.context.analytics);
            (0, superstruct_1.assert)(product, (0, superstruct_1.nonempty)((0, superstruct_1.string)()), "ADP Web SDK needs to be initialized with product line code (product.line_name)");
            (0, superstruct_1.assert)(version, (0, superstruct_1.nonempty)((0, superstruct_1.string)()), "ADP Web SDK needs to be initialized with product version (product.build_id)");
            return this.ipmDownloader.buildRuleEngines({ product, version });
        });
    }
    subscribe() {
        /** @todo subscribe to insights service */
        return Promise.reject(new Error("Not implemented"));
    }
}
exports.IpmMessageService = IpmMessageService;
_IpmMessageService_http = new WeakMap();
